var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSketchQuestionIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4d4c4d",
  d: "M31.627 39.108H8.372a7.48 7.48 0 0 1-7.48-7.48V8.371a7.48 7.48 0 0 1 7.48-7.48h23.255a7.48 7.48 0 0 1 7.481 7.48v23.255a7.48 7.48 0 0 1-7.48 7.481"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.623 25.346c-.973.982-1.963 1.963-2.945 2.945h4.518l.687-.686zM28.98 16.884l-5.154-4.922a.914.914 0 0 0-1.293.03l-4.997 5.233-1.98 2.073-.662 4.001-1.283 1.344 3.173 3.029 1.284-1.344 3.964-.845h.002l1.979-2.074 4.997-5.233a.914.914 0 0 0-.03-1.292"
}))));
export default SvgSketchQuestionIcon;